import React from "react";
import { Wrapper, Title, Button } from "./FavList.styles";

function FavList() {
  return (
    <Wrapper>
      <Title>Black Adam</Title>
      <Button>remove</Button>
    </Wrapper>
  );
}

export default FavList;
